import { useCallback, useState } from 'react';

import { message } from 'antd';

import {
  AdminFonctionnelControllerApi,
  DossierDtoAdminFonctionnel,
  DossierResponseDto,
} from 'lib_api/lib/api/gen';

import { backAlertMessage } from 'hooks/utils/backAlertMessage';

import {
  Controller,
  SetDossier,
  SubmitFunction,
  UploadPieceJointeFormValues,
} from './types';

export default function useSubmitUploadPieceJointe(
  controller: Controller,
  dossierId: string,
  setDossier: SetDossier,
  closeModal: () => void,
): SubmitFunction {
  const [inProgress, setInProgress] = useState<boolean>(false);

  const getUploadPieceJointe = useCallback(() => {
    return controller instanceof AdminFonctionnelControllerApi
      ? controller.uploadPieceJointeUsingPOST1.bind(controller)
      : controller.uploadPieceJointeUsingPOST.bind(controller);
  }, [controller]);

  return {
    submit: (values: UploadPieceJointeFormValues) => {
      setInProgress(true);

      return getUploadPieceJointe()(dossierId, values.type ?? '', values.file)
        .then(
          setDossier as (
            dossier: DossierDtoAdminFonctionnel | DossierResponseDto,
          ) => void,
        )
        .then(
          () =>
            void message.success(`Le document a bien été joint au dossier.`),
        )
        .then(closeModal)
        .catch((error: Response) => {
          void backAlertMessage(error);
        })
        .finally(() => {
          setInProgress(false);
        });
    },
    inProgress: inProgress,
  };
}
